import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { PAGE_SIZE } from 'core/utils/constants';
import httpclient from 'libs/Axios';
import { useEffect } from 'react';

export const useFetchBranchRole = (list, setlist) => {
  const authData = useAuth();
  useEffect(() => {
    const request = async () => {
      const response = await httpclient().get(
        `/data/branchRole/list/${authData?.BRANCH_ID}?${PAGE_SIZE}`);
      const data = response?.data?.data.BranchRoleList;
      setlist(data);
    };

    request();
  }, [authData?.BRANCH_ID, setlist]);
};
